import AgendaItem from './AgendaItem';

export default AgendaItem;